export const Bio = {
    name: "Gauri Bidwai",
    roles: [
      "Full Stack Developer",
      "MERN Stack Developer",
      "Programmer",
      "Academic Mentor"
    ],
    description:"I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/gitusergb",
    // resume:"https://drive.google.com/file/d/1ndzUWyL_pZ_7b4zT2KqhuRHk0f1HAouW/view",
    resume:"https://drive.google.com/file/d/1ivMBfA5BFkVx1434XjgjJofvFSptU1PV/view",
    linkedin: "https://www.linkedin.com/in/gauri-bidwai/",
    twitter: "#",
    insta: "https://www.instagram.com/b_gauri_13/",
    facebook: "#",
    email:"gauribidwai94@gmail.com"
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "Next Js",
          image: "https://i.ibb.co/PsKY61W6/next-js-logo.png",
        },
       
        // {
        //   name: "Next Js",
        //   image:
        //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        // },
        
        {
          name: "TypeScript",
          image:
            "https://i.ibb.co/83G5tx3/Type-Script.jpg",
        },
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "Chakra UI",
          image:
            "https://i.ibb.co/kWZJH5k/chakra.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Material UI",
          image:
            "https://i.ibb.co/C5Hbp2Sw/material-UI.png",
        },
        {
          name: "Tailwind CSS",
          image:
            "https://i.ibb.co/MxzzfGkC/Tailwind-CSS.png",
        },
       
      ],
    },
    {
      title: "Backend",
      skills: [
        
        
        {
          name: "Nest Js",
          image: "https://nestjs.com/logo.svg",
        },
       
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "Express Js",
          image:
            "https://i.ibb.co/1JMtLXHN/download.png",
            
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Postgresql",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },

        {
          name: "SOQL",
          image:
            "https://i.ibb.co/Vcb3Srdq/SOQL.jpg",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Mongoose",
          image:
            "https://i.ibb.co/Ng6Ln5Nt/Mongoose.png",
        },
        {
          name: "Apex",
          image:
            "https://i.ibb.co/TMGQL0PZ/apex.png",
        }
        // {
        //   name: "Firebase",
        //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        // },
      ],
    },
    // {
    //   title: "Android",
    //   skills: [
    //     {
    //       name: "Java",
    //       image:
    //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    //     },
    //     {
    //       name: "Kotlin",
    //       image:
    //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
    //     },
    //     {
    //       name: "XML",
    //       image:
    //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
    //     },
    //     {
    //       name: "Android Studio",
    //       image:
    //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
    //     },
    //   ],
    // },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "GitLab",
          image:
            "https://images.seeklogo.com/logo-png/44/2/gitlab-logo-png_seeklogo-440184.png",
        },
        // {
        //   name: "Docker",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        // },
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
        },
        // {
        //   name: "Adobe XD",
        //   image:
        //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
        // },
        {
          name: "Figma",
          image:
            "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
        },
        {
          name: "Vercel",
          image:"https://i.ibb.co/dwdHSNR4/vercel.png",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://colleges18.s3.ap-south-1.amazonaws.com/Lovely_Professional_University_04_37bc70298e.png",
      role: "Academic Mentor",
      company: "Lovely Professional University, Phagwara, Punjab",
      date: "2026",
      desc: "working as an Academic Mentor at Lovely Professional University, guiding students in their academic journey and providing support in various subjects.",
      skills: [
        "React",
        "Next js"
      ],
      // doc: "#",
      
    },
    {
      id: 1,
      img: "https://www.medianv.com/wp-content/uploads/2023/03/logo.png.webp",
      role: "SDE1",
      company: "MediaNV",
      date: "2026",
      desc: "Developed NestJS-based backend features for Form and Scraper modules, including PDF/image uploads and RESTful APIs for admin and customer portals.",
      skills: [
        "React",
        "Next js",
        "nestjs",
        "Node.js"
      ],
      // doc: "#",
      
    },
    {
      id: 2,
      img: "https://i.ibb.co/dwjcXsYF/Warp-Drive-Logo-01-edited.jpg",
      role: "Technical Specialist",
      company: "WarpDrive Tech Works, Bangalore, India",
      date: "2025",
      desc: "Built and customized solutions on the Salesforce platform, integrating AI chatbot functionality to enhance user engagement and automation.",
      skills: [
        "Apex",
        "HTML",
        "CSS",
        "JavaScript",
        "SOQL",
        "SQL",
        "Node.js"
      ],
      // doc: "#",
      
    },
    {
      id: 3,
      img: "https://www.maestrointellect.com/assets/images/Mlogo.png",
      role: "Trainee Software Developer",
      company: "Maestro Intellect,Pune,India",
      date: "2019",
      desc: "Worked on the frontend of the web application using HTML,CSS,JavaScript.",
      skills: [
        "HTML",
        "CSS",
        "JavaScript",
      ],
      // doc: "#",
      
    }
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://i.ibb.co/wQd3ZGp/masai.pnghttps://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxjbdGm_IQ83kK9LDN_VWkQtlRspVvS-XH7Kayhu5sNlF4QCpVG_9BM9b2rxXPs5HdkA&usqp=CAU",
      school: "Masai School,HSR Layout Bengaluru,Karnataka",
      date: "July 2023 - Present",
      grade: "A",
      desc: "I am currently pursuing Full Stack Web Development at masai.Where,I have not only gained technical knowledge but also leared communication, soft skills, problem solving , and how to collaborate with a team and work on projects within the given time.",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ3mMEivvLHa5cJWwEzZpXrbRE6NPBcCfnrhA&usqp=CAU",
      school: "P.E.S Modern College Of Engineering,Pune.",
      date: "Oct 2016 - July 2019",
      grade: "63%",
      desc: "I completed my Master of Computer Application at P.E.S Modern College Of Engineering,Pune.",
      degree: "MCA",
    },
    {
      id: 2,
      img: "https://i.ibb.co/JCJNq8P/rdg.jpg",
      school: "Smt. RDG College, Akola",
      date: "Apr 2013 - June 2016",
      grade: "65%",
      desc: "I completed my Bachelor of Computer Application at Smt. RDG College, Akola",
      degree: "BCA",
    },
  ];
  
  export const projects = [
    {
      id: 1,
      title: "WOOD HEART",
      date: "Jun 2023 - Jul 2023",
      description:"The project involves creating a full-fledged online furniture retail website where users can register, browse a wide range of furniture products, add items to their shopping cart, make secure purchases, and leave reviews. The project was a collaborative effort completed in just five days. ",
      image:
        "https://dev-to-uploads.s3.amazonaws.com/uploads/articles/93hmh3xz6lp15knmvaww.png",
      tags: [
        "HTML5",
        "CSS3",
        "TypeScript",
        "Chakra UI"
      ],
      category: "web app",
      github: "https://github.com/JayachandranRamu/Wood-Heart",
      webapp: "https://wood-heart.vercel.app/",
      member: [
        {
          name: "Gauri Bidwai",
          img: "https://i.ibb.co/dQgFLHW/my-passport-photo.jpg",
          linkedin: "https://www.linkedin.com/in/gauri-bidwai/",
          github: "https://github.com/gitusergb",
        },
        {
          name: "Jayachandran Ramu",
          img: "https://avatars.githubusercontent.com/u/121331649?s=96&v=4",
          linkedin: "https://www.linkedin.com/in/jayachandran-ramu-93a74a247/",
          github: "https://github.com/JayachandranRamu",
        },
        {
          name: "Narendra Patel",
          img: "https://avatars.githubusercontent.com/u/121709505?s=64&v=4",
          linkedin: "https://www.linkedin.com/in/narendra-patel-1ba56925a/",
          github: "https://github.com/Narendra-patel-np",
        },
        {
          name: "Abhay V",
          img: "https://avatars.githubusercontent.com/u/112228231?s=64&v=4",
          linkedin: "https://www.linkedin.com/in/abhay-v-935738243/",
          github: "https://github.com/abii225",
        },
      ],
    },
    {
      id: 2,
      title: "BeCool",
      date: "sep 2022",
      description:
        "BeCool.com is an E-Commerce website, where one could buy a varities of clothes of different category. This is the Clone of Bewakoof.com",
      image:
        "https://i.ibb.co/R0RPg2D/becool.png",
      tags: ["Js", "HTML","css"],
      category: "web app",
      github: "https://github.com/gitusergb/becool",
      webapp: "https://resilient-entremet-1e5aa0.netlify.app/",
      member: [
        {
          name: "Gauri Bidwai",
          img: "https://i.ibb.co/dQgFLHW/my-passport-photo.jpg",
          linkedin: "https://www.linkedin.com/in/gauri-bidwai/",
          github: "https://github.com/gitusergb",
        },
        {
          name: "Rahul Singh Kushwah",
          img: "https://avatars.githubusercontent.com/u/112858970?v=4",
          linkedin: "https://www.linkedin.com/in/rahul-singh-kushwah-6a664b172/",
          github: "https://github.com/Rahul1905-sk",
        },
      ],
    },
    {
      id: 2,
      title: "mymovieapp",
      date: "",
      description:
        "Practice Movie app and clone of hotstar",
      image:
        "https://i.ibb.co/PCK0tx9/mymovieapp.png",
      tags: [
        "HTML",
        "CSS",
        "Js",
      ],
      category: "Small_web app",
      github: "#",
      webapp: "https://mymovieappauthentication.netlify.app/",
      member: [
        {
          name: "Gauri Bidwai",
          img: "https://i.ibb.co/dQgFLHW/my-passport-photo.jpg",
          linkedin: "https://www.linkedin.com/in/gauri-bidwai/",
          github: "https://github.com/gitusergb",
        }
      ],
    },
    {
      id: 3,
      title: "MoneyMingle",
      date: "June 2023 - June 2023",
      description:
        "MoneyMingle is a financial application that helps users quickly convert their Money to other currencies.",
      image:
        "https://i.ibb.co/nRY66tg/money-convertor.png",
      tags: [ "HTML",
      "CSS",
      "JavaScript"],
      category: "web app",
      github: "https://github.com/gitusergb/mm",
      webapp: "https://poetic-jalebi-91817f.netlify.app/",
      member: [
        {
          name: "Gauri Bidwai",
          img: "https://i.ibb.co/dQgFLHW/my-passport-photo.jpg",
          linkedin: "https://www.linkedin.com/in/gauri-bidwai/",
          github: "https://github.com/gitusergb",
        },
        {
          name: "Tapish Agrawal",
          img: "https://avatars.githubusercontent.com/u/110096013?v=4",
          linkedin: "https://www.linkedin.com/in/tapish-agrawal/",
          github: "https://github.com/Tapishagrawal",
        },
      ],
    },
    {
      id: 1,
      title: "Singing Digital Clock",
      date: "",
      description:
        "Animated colored Singing Digital Clock",
      image:
        "https://i.ibb.co/8c2Dk2C/singing-clock.png",
      tags: [
        "HTML",
        "CSS",
        "Js",
        "React"
      ],
      category: "Small_web app",
      github: "https://github.com/gitusergb/AnImAtIonN_",
      webapp: "https://singing-digital-clock.netlify.app/",
    },
    {
      id: 3,
      title: "Animated login page",
      date: "",
      description:
        "Animated login page",
      image:
        "https://i.ibb.co/HV2F05N/login-reducer-hook2.png",
      tags: [
        "HTML",
        "CSS",
        "Js",
        "React"
      ],
      category: "Small_web app",
      github: "https://github.com/gitusergb/AnImAtIonN_",
      webapp: "https://prismatic-blini-e73b28.netlify.app/",
    },
    {
      id: 4,
      title: "Image Creator :ICre",
      date: "29-Jan",
      description:
        "To generate images from that exactly text user providing ,I have tried to create this Image Creator :ICre",
      image:
        "https://i.ibb.co/6tY8Jhy/scr2.png",
      tags: [
        "Node",
        "Express",
        "MongoDB",
        "React",
        "Tailwind",
        "DALL-E",
        "Cloudinary"
      ],
      category: "Small_web app",
      github: "https://github.com/gitusergb/ICre_AI",
      webapp: "https://lighthearted-dieffenbachia-6a1619.netlify.app/",
    },
    {
      id: 5,
      title: "My_Notes_ APP",
      date: "20-Apr",
      description:
        "A Basic app created using react,after logged in you can create,update and delete your notes.",
      image:
        "https://i.ibb.co/9ZShZ3Z/my-notes-app.png",
      tags: [
        "Node",
        "Express",
        "MongoDB",
        "React",
        "JavaScript",
      ],
      category: "Small_web app",
      github: "https://github.com/gitusergb/My_Notes_WebApp",
      webapp: "https://timely-tarsier-0595a2.netlify.app/",
    },
    {
      id: 6,
      title: "My_YouTube",
      date: "9-March",
      description:
        "YouTube, built using React JS and Material UI.",
      image:
        "https://i.ibb.co/xjFnz5d/movies.png",
      tags: [
        "Node",
        "Express",
        "RapidAPI",
        "React",
        "JavaScript",
      ],
      category: "Small_web app",
      github: "https://github.com/gitusergb/MyYouTube",
      webapp: "https://roaring-nasturtium-35c702.netlify.app/",
    },

  ];
  
  export const TimeLineData = [
    { year: 2013, text: "Started my BCA" },
    { year: 2016, text: "Started my MCA" },
    { year: 2019, text: "Worked as Intern" },
  ];